import { useModel } from '@umijs/max';

import { getLocale } from 'umi';

/**
 * 语言常量定义
 */
export const LANG_EN = 'en';
export const LANG_ZH = 'zh';
export const LANG_DEFAULT = LANG_EN;

/**
 * 语言标签映射配置 (Fallback)
 */
export const languageLabels: Record<string, string> = {
	[LANG_EN]: 'English',
	[LANG_ZH]: '简体中文',
	'en-US': 'English', // 兼容旧值
	'zh-CN': '简体中文' // 兼容旧值
};

/**
 * 获取内容语言 (从 UI 语言转换)
 * en-US -> en
 * zh-CN -> zh
 */
export const getContentLanguage = (): string => {
	const uiLocale = getLocale();
	if (uiLocale === 'zh-CN') {
		return LANG_ZH;
	}
	return LANG_EN;
};

/**
 * 获取语言显示名称
 */
export const getLanguageLabel = (locale: string): string => {
	return languageLabels[locale] || locale;
};

/**
 * Hook: 获取支持的语言列表 (From Global State)
 */
export const useSupportedLanguages = (): Array<{ value: string; label: string; flag?: string }> => {
	const { initialState } = useModel('@@initialState');
	return (
		initialState?.languages || [
			{ value: LANG_ZH, label: '简体中文', flag: '🇨🇳' },
			{ value: LANG_EN, label: 'English', flag: '🇺🇸' }
		]
	);
};

/**
 * @deprecated Use useSupportedLanguages hook instead
 */
export const getSupportedLanguages = (): Array<{ value: string; label: string }> => {
	console.warn('getSupportedLanguages is deprecated. Use useSupportedLanguages hook instead.');
	return [{ value: LANG_EN, label: 'English' }];
};

/**
 * 检查是否为支持的语言
 */
export const isSupportedLanguage = (locale: string): boolean => {
	// This is a rough check, ideally should use the hook context but this is a pure function
	// We might need to refactor usages of this to use the hook as well
	return [LANG_ZH, LANG_EN, 'zh-CN', 'en-US'].includes(locale);
};

/**
 * 获取默认语言
 */
export const getDefaultLanguage = (): string => {
	return LANG_DEFAULT;
};
